import React, { useRef } from 'react';
import { HotTable } from '@handsontable/react';

import Handsontable from 'handsontable/base';
import { registerAllModules } from 'handsontable/registry';

registerAllModules();

const ExcelTable = ({
  data = [],
  rowHeaders = true,
  colHeaders,
  custumBorders,
  colWidths = [],
  multiColumnSorting = true,
  height = 'auto',
  width = 'auto',
  autoWrapRow = true,
  autoWrapCol = true,
  filters = false,
  dropdownMenu = false,
  contextMenu = false,
  manualRowMove = false,
  onSave = () => { },
  style = {},
  className,
  onChangeCell = () => { },
  ...props
}) => {
  const hotRef = useRef(null);

  let saveClickCallback = () => {
    const hot = hotRef.current.hotInstance;

    let res = hot.getData();

    console.log('hi', res);

    onSave();
  };

  return (
    <div
      className={className}>
      <HotTable
        customBorders={true}
        ref={hotRef}
        colWidths={colWidths}
        multiColumnSorting={multiColumnSorting}
        colHeaders={colHeaders}
        data={data}
        custumBorders={custumBorders}
        rowHeaders={rowHeaders}
        height={height}
        width={width}
        stretchH={'all'}
        autoWrapRow={autoWrapRow}
        autoWrapCol={autoWrapCol}
        filters={filters}
        dropdownMenu={dropdownMenu}
        contextMenu={contextMenu}
        manualRowMove={manualRowMove}
        afterChange={function (changes, source) {
          if (source !== 'loadData' && source !== 'updateData') {
            let item_one = changes[0];

            onChangeCell(item_one[0], item_one[1], item_one[3]);
            console.log(JSON.stringify(changes, source));
          }
        }}
        licenseKey="non-commercial-and-evaluation" // for non-commercial use only
        {...props}
      />
    </div>
  );
};

export default ExcelTable;
